export default "__VITE_ASSET__1ed936af__"